import { useMemo } from "react";

import { Order } from "@web-app/types";

interface UseEstimatedPickupTimeParams {
  isRouteSequenceValid: boolean;
  orderIds: string[];
  orders: Map<string, Order | Partial<Order>> | undefined;
  routeEstimatedPickupTime?: Date | string | null;
}

export function useEstimatedPickupTime({
  orderIds,
  orders,
  routeEstimatedPickupTime,
  isRouteSequenceValid,
}: UseEstimatedPickupTimeParams): Date | null {
  return useMemo(() => {
    const hasLongTimeFramePickup = () => {
      if (orderIds.length === 0) return false;

      const firstOrder = orders?.get(orderIds[0]);
      if (
        !firstOrder ||
        firstOrder.type !== "ROUTE_OPT_PICKUP" ||
        !firstOrder.scheduledStartDateTime ||
        !firstOrder.scheduledEndDateTime
      )
        return false;

      const scheduledStart = new Date(firstOrder.scheduledStartDateTime);
      const scheduledEnd = new Date(firstOrder.scheduledEndDateTime);
      const diffInMs = scheduledEnd.getTime() - scheduledStart.getTime();
      const diffInHours = diffInMs / (1000 * 60 * 60);
      return diffInHours >= 1.5;
    };

    const firstOrderId = orderIds?.[0];
    const firstOrder = orders?.get?.(firstOrderId);

    if (
      firstOrder &&
      firstOrder.scheduledStartDateTime &&
      orders &&
      isRouteSequenceValid &&
      hasLongTimeFramePickup()
    ) {
      return new Date(
        routeEstimatedPickupTime || firstOrder.scheduledStartDateTime,
      );
    }

    return null;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderIds]);
}
